import type { ComponentPropsWithRef } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'
import { fieldClassName } from './field-class'

/** className は高さの指定に使う（既定 120px。お問い合わせは Figma で 160px なので h-40 を渡す） */
export const Textarea = ({
  register,
  className = 'h-30',
  ...rest
}: ComponentPropsWithRef<'textarea'> & { register: UseFormRegisterReturn }) => {
  return (
    <textarea
      defaultValue={''}
      {...rest}
      className={`${fieldClassName} ${className} resize-none`}
      {...register}
    />
  )
}
